import styled from "styled-components";
export const CustomersWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
